module.exports = __webpack_public_path__ + "static/media/fit_screen.4b120da1.svg";